export default "__VITE_ASSET__8ecde2f4__"